import api from "../auth/api";
import { getPushTokenFields } from "../auth/pushToken";
import type {
  RegisterRequest,
  LoginRequest,
  ForgotPasswordRequest,
  VerifyEmailRequest,
  AuthResponse,
  ForgotPasswordResponse,
  VerifyEmailResponse,
  CheckOtpForgotPasswordRequest,
  CheckOtpForgotPasswordResponse,
  ResetPasswordOtpRequest,
  ResetPasswordOtpResponse,
  GoogleAuthRequest,
  GoogleAuthResponse,
  AppleAuthRequest,
  AppleAuthResponse,
  DeviceTokenRequest,
  LogoutRequest,
} from "./auth.type";

// Register user
export const registerUser = async (
  data: RegisterRequest
): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/register", {
    ...data,
    ...getPushTokenFields(),
  });
  return response.data;
};

// Login user
export const loginUser = async (data: LoginRequest): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/login", {
    ...data,
    ...getPushTokenFields(),
  });
  return response.data;
};

// Register the native push (FCM) device token for the current session
export const sendDeviceToken = async (
  data: DeviceTokenRequest
): Promise<void> => {
  await api.post("/auth/device-token", data);
};

// Logout the current session (optionally invalidating the device token)
export const logoutUser = async (data: LogoutRequest = {}): Promise<void> => {
  await api.post("/auth/logout", data);
};

// Forgot password
export const forgotPassword = async (
  data: ForgotPasswordRequest
): Promise<ForgotPasswordResponse> => {
  const response = await api.post<ForgotPasswordResponse>(
    "/auth/forgot-password",
    data
  );
  return response.data;
};

// Verify email
export const verifyEmail = async (
  data: VerifyEmailRequest
): Promise<VerifyEmailResponse> => {
  const response = await api.post<VerifyEmailResponse>(
    "/auth/verify-email",
    data
  );
  return response.data;
};

// Check OTP for forgot password
export const checkOtpForgotPassword = async (
  data: CheckOtpForgotPasswordRequest
): Promise<CheckOtpForgotPasswordResponse> => {
  const response = await api.post<CheckOtpForgotPasswordResponse>(
    "/auth/check-otp-forgot-password",
    data
  );
  return response.data;
};

// Reset password with OTP
export const resetPasswordOtp = async (
  data: ResetPasswordOtpRequest
): Promise<ResetPasswordOtpResponse> => {
  const response = await api.post<ResetPasswordOtpResponse>(
    "/auth/reset-password-otp",
    data
  );
  return response.data;
};

// Google authentication (sign-in/sign-up)
export const googleAuth = async (
  data: GoogleAuthRequest
): Promise<GoogleAuthResponse> => {
  const response = await api.post<GoogleAuthResponse>("/auth/google", {
    ...data,
    ...getPushTokenFields(),
  });
  return response.data;
};

// Apple authentication (sign-in/sign-up)
// Backend endpoint: POST /auth/apple
export const appleAuth = async (
  data: AppleAuthRequest
): Promise<AppleAuthResponse> => {
  const response = await api.post<AppleAuthResponse>("/auth/apple", {
    ...data,
    ...getPushTokenFields(),
  });
  return response.data;
};
